import $api from "../Api";
import ResponseChecker from "../Middlewares/ResponseChecker";
import { defaultMessages } from "../enums/responseMessages.js";
import Endpoints from "../Endpoints";

/**
 * @param {{ params?: object, query?: object }} [option]
 */
export const GetAll = async (option) => {
  const response = await $api.get(Endpoints.MeetingResult.GetAll(option));
  return ResponseChecker(defaultMessages, response);
};

/**
 * @param {{ title: string, description?: string, color?: string|null, bgColor?: string|null, order?: number }} form
 */
export const Create = async (form) => {
  const response = await $api.post(Endpoints.MeetingResult.Create(), form);
  return ResponseChecker(defaultMessages, response);
};

/**
 * @param {{ params: { id: string }, query?: object }} option
 */
export const GetById = async (option) => {
  const response = await $api.get(Endpoints.MeetingResult.GetById(option));
  return ResponseChecker(defaultMessages, response);
};

/**
 * @param {{ title?: string, description?: string, color?: string|null, bgColor?: string|null, order?: number, isActive?: boolean }} form
 * @param {{ params: { id: string }, query?: object }} option
 */
export const Update = async (form, option) => {
  const response = await $api.put(Endpoints.MeetingResult.Update(option), form);
  return ResponseChecker(defaultMessages, response);
};

/**
 * @param {{ params: { id: string }, query?: object }} option
 */
export const Delete = async (option) => {
  const response = await $api.delete(Endpoints.MeetingResult.Delete(option));
  return ResponseChecker(defaultMessages, response);
};

export default {
  GetAll,
  Create,
  GetById,
  Update,
  Delete,
};
